import { FC, useMemo } from "react";
import { Skeleton } from "../base/skeleton";
import { Img } from "../base/img";

interface FeatureAttachmentProps {
  url: string;
}

export const FeatureAttachment: FC<FeatureAttachmentProps> = ({ url }) => {
  const { alt, fileName: _fileName } = useMemo(() => {
    const fileName = url.split("/").pop();

    return {
      fileName,
      alt: fileName || "Attachment",
    };
  }, [url]);

  return (
    <a
      className="border-primary bg-paper relative block h-22.5 w-30 rounded border-2 overflow-hidden"
      href={url}
      target="_blank"
    >
      <Skeleton className="h-full w-full rounded" />
      <Img className="bg-paper absolute inset-0 w-full h-full object-center" src={url} alt={alt} />
    </a>
  );
};
